import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

const i18nInstance = i18n.createInstance();

i18nInstance
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: { translation: require('./locales/en/translation.json') },
      es: { translation: require('./locales/es/translation.json') },
    },
  });

export const getCountryOptions = () => {
  countries.registerLocale(enLocale); // Ensure locale is registered
  return Object.entries(countries.getNames('en', { select: 'official' })).map(([code, name]) => ({
    value: code,
    label: name,
  }));
};

export const COUNTRY_CODE_TO_NAME_MAP = getCountryOptions().reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});

export default i18nInstance;
